import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { BaseSpinner } from '../common/BaseSpinner';

type ActivityLoadMoreButtonProps = {
    hasMore: boolean;
    isLoading: boolean;
    onLoadMore: () => void;
    eventLogsLength: number;
};

export const ActivityLoadMoreButton = ({ 
    hasMore, 
    isLoading, 
    onLoadMore, 
    eventLogsLength 
}: ActivityLoadMoreButtonProps) => {
    if (!hasMore && eventLogsLength > 0) {
        return (
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                padding: '20px',
                color: 'var(--tg-theme-hint-color)'
            }}>
                <Text style={{ fontSize: '14px' }}>
                    No more activity to load
                </Text>
            </Box>
        );
    }

    if (!hasMore) {
        return null;
    }

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                padding: '20px',
                minHeight: '60px'
            }}
        >
            {isLoading ? (
                <BaseSpinner size="m" />
            ) : (
                <Text 
                    style={{ 
                        color: 'var(--tg-theme-link-color)', 
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        fontSize: '16px',
                        padding: '10px 20px',
                        border: '1px solid var(--tg-theme-link-color)',
                        borderRadius: '6px'
                    }}
                    onClick={onLoadMore}
                >
                    Load More Activity
                </Text>
            )}
        </Box>
    );
}; 